var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMrFamilyStepAttention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 54.493,
    height: 54.5,
    viewBox: "0 0 54.493 54.5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 74",
    d: "M46.3419 8.15811C51.0163 12.8325 53.8134 19.0594 54.203 25.6585C54.5927 32.2576 52.5478 38.7704 48.456 43.9624C44.3641 49.1544 38.5097 52.6649 32.0023 53.8284C25.4949 54.992 18.7867 53.7277 13.1492 50.2753C7.51173 46.8229 3.33671 41.4223 1.41546 35.097C-0.505786 28.7717 -0.0397502 21.9614 2.72524 15.9568C5.49023 9.95224 10.362 5.17068 16.4173 2.51842C22.4725 -0.133848 29.2903 -0.472497 35.5786 1.56665",
    stroke: "#209CFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeDasharray: "2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMrFamilyStepAttention);
export default __webpack_public_path__ + "static/media/MrFamily_Step_Attention.465bc79c89062520335045a5af141ea6.svg";
export { ForwardRef as ReactComponent };